const LEGACY_PRICE_TYPE_ORDER = Object.freeze({
  Breakdown: 1,
  "Fixed Charge": 2,
  "Run Charge": 3,
  "Inbound freight": 4,
  Brokerage: 4,
  Duty: 4,
});

export const resolvePersistedPricingSortOrder = (value) => {
  const numeric = Number(value);
  return Number.isInteger(numeric) && numeric >= 0 ? numeric : null;
};

export const hasPersistedPricingSortOrder = (value) =>
  resolvePersistedPricingSortOrder(value) !== null;

const getLegacyPriceTypeOrder = (row = {}) =>
  LEGACY_PRICE_TYPE_ORDER[row?.priceType] || 5;

const getDeterministicRowTieBreaker = (row = {}, fallbackIndex = 0) => {
  const persistedId = Number(row?.id);
  if (Number.isInteger(persistedId) && persistedId > 0) return persistedId;

  const stableText = String(
    row?.tempRowId ||
    row?.sku ||
    row?.chargeName ||
    row?.color ||
    row?.size ||
    ""
  ).trim();

  if (stableText) return stableText.toLowerCase();
  return fallbackIndex;
};

const compareLegacyPricingRows = (left = {}, right = {}, leftIndex = 0, rightIndex = 0) => {
  const typeDelta = getLegacyPriceTypeOrder(left) - getLegacyPriceTypeOrder(right);
  if (typeDelta !== 0) return typeDelta;

  const leftTieBreaker = getDeterministicRowTieBreaker(left, leftIndex);
  const rightTieBreaker = getDeterministicRowTieBreaker(right, rightIndex);
  if (leftTieBreaker < rightTieBreaker) return -1;
  if (leftTieBreaker > rightTieBreaker) return 1;
  return leftIndex - rightIndex;
};

export const sortPricingRowsForHydration = (rows = []) => {
  const indexedRows = [...rows].map((row, index) => ({ row, index }));
  const hasAnyPersistedOrder = indexedRows.some(({ row }) =>
    hasPersistedPricingSortOrder(row?.sortOrder ?? row?.SortOrder)
  );

  const sorted = indexedRows.sort((leftEntry, rightEntry) => {
    const leftSortOrder = resolvePersistedPricingSortOrder(
      leftEntry.row?.sortOrder ?? leftEntry.row?.SortOrder
    );
    const rightSortOrder = resolvePersistedPricingSortOrder(
      rightEntry.row?.sortOrder ?? rightEntry.row?.SortOrder
    );

    if (hasAnyPersistedOrder) {
      if (leftSortOrder !== null && rightSortOrder !== null && leftSortOrder !== rightSortOrder) {
        return leftSortOrder - rightSortOrder;
      }

      if ((leftSortOrder !== null) !== (rightSortOrder !== null)) {
        return leftSortOrder !== null ? -1 : 1;
      }
    }

    return compareLegacyPricingRows(
      leftEntry.row,
      rightEntry.row,
      leftEntry.index,
      rightEntry.index
    );
  });

  return sorted.map(({ row }) => row);
};

export const assignSequentialPricingSortOrder = (rows = []) =>
  (rows || []).map((row, index) => ({
    ...row,
    sortOrder: index,
  }));
